import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
declare var process: any;

@Injectable()
export class AppConfig {
    public domain: string;
    public companyId: string;
    public companyName: string;
    public language: string;
    public locale: string;
    public currency: string;
    public device: boolean;

    public loaded: Promise<void>;

    constructor(private http: Http, private location: string) {
        this.loaded = this.load().then(x => x);
    }

    async load() {
        var x = await this.http.get(this.location).map(x => x.json() as AppConfig).toPromise().catch((err) => {
            throw Error('Failed to load configuration!');
        });
        this.domain = x.domain;
        this.companyId = x.companyId;
        this.companyName = x.companyName;
        this.currency = x.currency;
        this.device = x.device;
        this.language = x.language;
        this.locale = x.locale;
    }
}


// WEBPACK FOOTER //
// ./src/config/app.config.ts